import type { CustomValidatorResponse, ICustomFunctionValueType } from "@ceeferenderer/fe-renderer-sdk";
import { RsCustomValidation } from "@ceeferenderer/fe-renderer-sdk";
import { ics } from "./icsGen";
import { azureTokenInfo } from "../../utils/azureTokenInfo";
import { envConfig } from "../../config/envConfigs";
import { environment } from "../../constants/environment";
import { getDeviceType } from "../../utils/deviceType";
import { loggingFetch } from "../../utils/loggingFetch";
import { postLoggerEventDetails } from "../../utils/nifiLogger";

RsCustomValidation.bind({
  TelephoneNumber: (value: ICustomFunctionValueType, _argument: unknown, element?: Element) => {
    let match = true;
    value = value ? value.toString() : "";
    let validatorResult: CustomValidatorResponse;
    const input: any = element;
    if (value) {
      const phoneRegex = /^(?:\+1)?(?:\(\d{3}\)|\d{3})[ -]?\d{3}[ -]?\d{4}$/;
      match = phoneRegex.test(value);
      validatorResult = {
        message: input?.getAttribute("data-invalid-message"),
        value: match,
      };
    } else {
      validatorResult = {
        message: input?.getAttribute("data-validation-message"),
        value: false,
      };
    }
    return validatorResult;
  },
  email: (value: ICustomFunctionValueType, _argument?: unknown, element?: Element) => {
    let match = true;
    value = value ? value.toString() : "";
    let validatorResult: CustomValidatorResponse;
    const input: any = element;
    if (value) {
      const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+)\.[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      match = emailRegex.test(value);
      validatorResult = {
        message: input?.getAttribute("data-invalid-message"),
        value: match,
      };
    } else {
      validatorResult = {
        message: input?.getAttribute("data-validation-message"),
        value: false,
      };
    }
    return validatorResult;
  },
  exportIcs: () => {
    console.warn("inside export ics");
    const cal_single = ics();
    console.warn(`check clall single ${cal_single}`);
    if (cal_single) {
      const icsSubject: any = document.getElementById("icsSubject")?.textContent;
      const icsDescription: any = document
        .getElementById("icsDescription")
        ?.textContent?.trimStart()
        .replaceAll("\n", "\\n");
      const icsAppointmentStartDateTime: any = document
        .getElementById("icsAppointmentStartDate")
        ?.textContent?.toLowerCase();
      const icsAppointmentEndDateTime: any = document
        .getElementById("icsAppointmentEndDate")
        ?.textContent?.toLowerCase();
      const icsAppointmentDate: any = document.getElementById("icsAppointmentDate")?.textContent;
      const icsAppointmentLocation: any = document.getElementById("icsAppointmentLocation")?.textContent;
      const icsTimezone: any = document.getElementById("icsTimezone")?.textContent;
      const icsAttendee: any = document.getElementById("icsAttendee")?.textContent;
      const icsEmailId: any = document.getElementById("icsEmailId")?.textContent;
      if (
        icsAppointmentStartDateTime &&
        icsAppointmentStartDateTime !== "" &&
        icsAppointmentEndDateTime &&
        icsAppointmentEndDateTime !== ""
      ) {
        const today = new Date(icsAppointmentDate);
        const dd: any = today.getDate();
        const mm: any = today.getMonth() + 1;
        const yyyy = today.getFullYear();
        const convertedApptDateStr: any = `${mm}/${dd}/${yyyy}`;
        const convertedStartDateStr: any = `${convertedApptDateStr} ${icsAppointmentStartDateTime.trim()}`;
        const convertedEndDateStr: any = `${convertedApptDateStr} ${icsAppointmentEndDateTime.trim()}`;
        cal_single.addEvent(
          icsSubject.trim(),
          icsDescription,
          icsAppointmentLocation.trim(),
          convertedStartDateStr,
          convertedEndDateStr,
          icsTimezone.trim(),
          icsAttendee.trim(),
          icsEmailId.trim()
        );
        console.warn(
          `ics data${icsSubject.trim()}${icsDescription}${icsAppointmentLocation.trim()}${convertedStartDateStr}${convertedEndDateStr}${icsTimezone.trim()}${icsAttendee.trim()}${icsEmailId.trim()}`
        );
        // cal_single.addEvent(
        //   "Best Day",
        //   "This is the best day to demonstrate a single event.",
        //   "New York",
        //   "8/7/2013 5:30 pm",
        //   "8/7/2013 6:00 pm",
        //   undefined
        // );
        cal_single.download("AppointmentEvent", ".ics");
      }
      return {
        message: "exit and refresh",
        value: true,
      };
    } else {
      return {
        message: "exit and refresh",
        value: true,
      };
    }
  },
  refreshPage: () => {
    return {
      message: "exit and refresh",
      value: true,
    };
  },
  returnToStorePage: () => {
    const result: any = {
      message: "exit and refresh",
      value: true,
    };
    window.open("https://www.xfinity.com/local/store-offers", "_self");
    return result;
  },
  navigateToXoe: () => {
    const selectedAddressValue: any = document.querySelector("#selectedAddressValue");
    const elocId = selectedAddressValue?.value || "";
    const locationId = elocId.replace(/-\d{3}$/, "");
    const addressInput: any = document.querySelector("address-typeahead input");
    const selectedAddress = addressInput?.value || "";
    // Extract zipCode from the address string (last 5-digit number)
    const zipMatch = selectedAddress.match(/\b(\d{5})\b/);
    const zipCode = zipMatch ? zipMatch[1] : "";

    if (locationId) {
      const overlayLoader = document.getElementById("overlayLoader");
      const callSetJourneyService = async () => {
        const requestBody = {
          feProcessId: envConfig?.appConfig?.setJourneyFlowId,
          ...envConfig?.appConfig?.appDetails,
          environment: environment,
          deviceType: getDeviceType(),
          locationId: locationId,
          zipCode: zipCode,
          streetAddress1: selectedAddress,
          elocId: elocId,
        };

        try {
          if (overlayLoader) overlayLoader.style.display = "block";
          const response = await loggingFetch(`${envConfig.urls.serviceability}`, {
            headers: {
              AuthType: "AzureAD",
              Authorization: `Bearer ${(await azureTokenInfo).access_token}`,
              "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(requestBody),
          });

          if (response.ok) {
            const result = await response.json();
            if (result?.handOffUrl) {
              window.open(result.handOffUrl, "xoeTab");
            } else {
              postLoggerEventDetails("R360_AV_SetJourney_No_HandOffUrl", "Retail_BusinessTransaction");
            }
          } else {
            postLoggerEventDetails("R360_AV_SetJourney_API_Failure", "Retail_BusinessTransaction");
          }
        } catch (error) {
          postLoggerEventDetails("R360_AV_SetJourney_API_Error", "Retail_BusinessTransaction");
        } finally {
          if (overlayLoader) overlayLoader.style.display = "none";
        }
      };

      callSetJourneyService();
    } else {
      postLoggerEventDetails("R360_AV_SetJourney_No_LocationId", "Retail_BusinessTransaction");
    }

    return {
      message: "navigate to XOE",
      value: true,
    };
  },
});
